// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__aFgte","info":"UpdateTermsInfo_info__1MetM"};